import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Reveal } from './Reveal';

export const ServiceCard = ({ service, index = 0, large = false }) => {
  const Icon = service.icon;
  const to = service.linkOverride || `/services/${service.slug}`;
  return (
    <Reveal delay={(index % 4) * 0.08} className="h-full">
      <Link
        to={to}
        data-testid={`service-card-${service.slug}`}
        className={`card-lift group relative flex h-full flex-col overflow-hidden rounded-2xl border-2 border-forest bg-forest p-7 sm:p-9 ${
          large ? 'lg:col-span-2' : ''
        }`}
      >
        <span
          className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100"
          style={{ backgroundColor: '#A8D5BA' }}
          aria-hidden="true"
        />
        <div className="img-frame -mx-7 -mt-7 mb-7 aspect-[16/9] sm:-mx-9 sm:-mt-9">
          <img src={service.image} alt={service.imageAlt} loading="lazy" />
        </div>
        <div className="mb-6 flex items-start justify-between">
          <span
            className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/15 text-goldlight transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110"
          >
            <Icon size={24} strokeWidth={1.8} />
          </span>
          <span className="font-mono text-sm font-medium text-white transition-colors duration-300 group-hover:text-goldlight">
            {service.num}
          </span>
        </div>
        <h3 className="font-display text-xl font-bold leading-snug text-white sm:text-2xl">
          {service.title}
        </h3>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-white">{service.short}</p>
        <span className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-goldlight">
          Explore Service
          <ArrowUpRight
            size={16}
            className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
          />
        </span>
      </Link>
    </Reveal>
  );
};
